import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BillingAccountListComponent } from './billing-account-list.component';

const routes: Routes = [
  {
    path: '',
    component: BillingAccountListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BillingAccountListRoutingModule {}
